import {RepromaterialByPartnersReport} from "../models/Report";
import {RepromaterialByPartnersReportTemplateData} from "./RepromaterialByPartnersReportTemplateData";
import {RepromaterialByPartnersReportImportTemplate} from "./RepromaterialByPartnersReportImportTemplate";
import {cloneDeep} from "lodash";

export const getRepromaterialByPartnersReportTemplate = (
    dataRepromaterial: RepromaterialByPartnersReport[],
    selectedPartner: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    return RepromaterialByPartnersReportImportTemplate(
        prepareData(
            dataRepromaterial,
            selectedPartner,
            dateFrom,
            dateTo
        )
    );
};

const prepareData = (
    documentDataRepromaterial: RepromaterialByPartnersReport[],
    selectedPartner: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    const templateData: RepromaterialByPartnersReportTemplateData = {
        partnerName: selectedPartner,
        repromaterialByPartnersData: cloneDeep(documentDataRepromaterial),
        dateFrom: dateFrom,
        dateTo: dateTo
    };

    return templateData;
};